(async () => {
    const estateCarouselContainer = document.querySelector(
        '[data-estate-carousel]',
    );

    if (estateCarouselContainer) {
        await import('/components/estate-carousel/estate-carousel-lazy.js');
    }
})();
